import React, { useState } from "react";
import { emailValidation, passwordValidation, requiredFieldValidation, passwordMatch } from '../../utils/validation'
import { Container } from '@material-ui/core';
import logo from '../../images/techStart.png';
import { Checkbox, InputField, PrimaryButton } from '../../elements'
import PhoneInputField from "../../elements/PhoneInputField";

const RegistrationPage = props => {

  const { isLoading, createUser } = props;

  const [fieldState, setFieldState] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    optional: {
      source: localStorage.getItem('source')
    }
  });

  const [errorState, setErrorState] = useState({
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    password: null,
    confirmPassword: null,
  });

  const [acceptTerms, setAcceptTerms] = useState(false)

  const onChange = event => {
    setFieldState({ ...fieldState, [event.target.name]: event.target.value });
  };

  const submitHandle = () => {
    let errors = {
      firstName: requiredFieldValidation(fieldState.firstName, 'First Name'),
      lastName: requiredFieldValidation(fieldState.lastName, 'Last Name'),
      email: requiredFieldValidation(fieldState.email, 'Email') || emailValidation(fieldState.email),
      phone: requiredFieldValidation(fieldState.phone, 'Phone number'),
      password: requiredFieldValidation(fieldState.password, 'Password') || passwordValidation(fieldState.password),
      confirmPassword: requiredFieldValidation(fieldState.confirmPassword, 'Confirm Password') || passwordValidation(fieldState.confirmPassword) || passwordMatch(fieldState.password, fieldState.confirmPassword)
    }
    setErrorState(errors);
    !Object.values(errors).some(el => !!el) && createUser(fieldState);
  }

  return (
    <div className="auth-page">
      <img src={logo} alt="logo" className="auth-logo" />
      <Container className="auth-card" maxWidth="sm">
        <div>
          <h3>Create your account</h3>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <InputField
              name='firstName'
              placeholder='First Name'
              value={fieldState.firstName}
              error={errorState.firstName}
              onChange={onChange}
              onEnterPress={submitHandle}
              disabled={isLoading}
              containerStyle={{ width: '100%', maxWidth: '220px', height: '70px' }}
            />
            <InputField
              name='lastName'
              placeholder='Last Name'
              value={fieldState.lastName}
              error={errorState.lastName}
              onChange={onChange}
              onEnterPress={submitHandle}
              disabled={isLoading}
              containerStyle={{ width: '100%', maxWidth: '220px', height: '70px' }}
            />
          </div>
          <InputField
            name='email'
            placeholder='Email'
            value={fieldState.email}
            error={errorState.email}
            onChange={onChange}
            onEnterPress={submitHandle}
            disabled={isLoading}
            containerStyle={{ height: '80px' }}
          />
          <PhoneInputField
            name='phone'
            placeholder='Phone number'
            value={fieldState.phone}
            error={errorState.phone}
            onChange={onChange}
          />
          <InputField
            name='password'
            type='password'
            placeholder='Password'
            value={fieldState.password}
            error={errorState.password}
            onChange={onChange}
            onEnterPress={submitHandle}
            disabled={isLoading}
            containerStyle={{ height: '80px' }}
          />
          <InputField
            name='confirmPassword'
            type='password'
            placeholder='Confirm Password'
            value={fieldState.confirmPassword}
            error={errorState.confirmPassword}
            onChange={onChange}
            onEnterPress={submitHandle}
            disabled={isLoading}
            containerStyle={{ height: '100px' }}
          />
          <div className='text-center'>
            <Checkbox
              label={'I accept the Terms of Use & Privacy Policy'}
              id='acceptTerms'
              name="acceptTerms"
              disabled={isLoading}
              checked={acceptTerms}
              onChange={() => setAcceptTerms(!acceptTerms)}
              style={{ marginLeft: '5px' }}
              labelPlacement='start' />
            <div className="text-center">
              <PrimaryButton onClick={submitHandle} disabled={!acceptTerms} isLoading={isLoading} fullWidth={true}>
                Register Now
                </PrimaryButton>
              <div style={{ height: '27px', marginTop: '10px' }}>
                {Boolean(props.error) && <div className="error">{props.error}</div>}
              </div>
            </div>
          </div>

        </div>
      </Container>
      <p className="text-center pb-4">
        Already have an account?{" "}
        <a href="/login">
          Sign in
        </a>
      </p>
    </div>
  );
};

export default RegistrationPage;
